require('../../vendor/history');
require('../../vendor/history-adapter-jquery');
require('../../vendor/features-slider');
require('../../common/widgets/wrike-intro');

require('./widgets/create');
require('./widgets/plan');
require('./widgets/quote');
require('./widgets/features');
require('./widgets/faq');
require('./widgets/cards-model');
require('./widgets/cards-view');
require('./widgets/cards');

require('../../common/widgets/wrike-outro');
(function() {
    window.apps = window.apps || {};
    window.apps.json = window.appsJson || [];
    window.apps.view = new window.apps.View();
    window.apps.model = new window.apps.Model();
    window.apps.intro = new window.wrike.widgets.Intro();
    window.apps.createWidget = new window.apps.CreateWidget();
    window.apps.planWidget = new window.apps.PlanWidget();
    window.apps.quoteWidget = new window.apps.QuoteWidget();
    window.apps.cardsWidget = new window.apps.CardsWidget();
    window.apps.featuresWidget = new window.apps.FeaturesWidget();
    window.apps.FaqWidget = new window.apps.FaqWidget();
    window.apps.outro = new window.wrike.widgets.Outro();
    window.typeOfPage = 'apps';
})();



// WEBPACK FOOTER //
// ./assets/js/projects/apps/apps.js